<template>
  <header id="app-header">
    <b-navbar id="app-header-navbar" toggleable="md" type="light" variant="light">
      <b-navbar-brand to="/" exact>
        <div class="responsive-img-container">
          <b-img src="https://www.assets.cms.vt.edu/images/HorizontalStacked/HorizontalStacked_RGB.svg"
                 fluid
                 alt="Virginia Tech Logo">
          </b-img>
        </div>
      </b-navbar-brand>
      <b-navbar-toggle id="btn-nav-toggle" target="nav_collapse">
        <slot>
          <span id="btn-nav-toggle-icon" class="navbar-toggler-icon"></span>
        </slot>
      </b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item v-if="!isHomePage" id="lnk-home" to="/" exact>Home</b-nav-item>
          <b-nav-item id="lnk-manageMember" to="/manageMember">Manage by Member</b-nav-item>
          <b-nav-item id="lnk-group-batch-renew" to="/group-batch-renew">Batch Renew</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown :text="username" right>
            <b-dropdown-item id="lnk-logout" to="/logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <p id="app-name">Group Manager</p>
  </header>
</template>

<script>
import { auth } from '../util/groups-mixin';

export default {
  name: 'app-header',
  mixins: [auth],
  computed: {
    isHomePage() {
      return this.$route.path === '/';
    },
  },
};
</script>
<style scoped>
  #app-name {
    max-height: 50px;
  }
  .responsive-img-container {
    width: 210px;
  }
  @media (min-width: 992px) {
    .responsive-img-container {
      width: 250px;
    }
  }
  header, #app-header-navbar {
    background-color: white !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue